export enum AnalysisType {
  ORIGINAL,
  REQUESTED_PLATE_RERUN,
  REQUESTED_SAMPLE_RERUN,
  INTERNAL_RERUN,
}
